import React, { FC } from 'react';
import { ServiceCardIconType } from '../../../../models/Common';
import { ReactComponent as InternetIcon } from '../../../../assets/images/services/Internet.svg';
import { ReactComponent as CabellTvIcon } from '../../../../assets/images/services/CabellTv.svg';
import { ReactComponent as BrizTvIcon } from '../../../../assets/images/services/BrizTv.svg';
import { ReactComponent as InternetPlusCabellTvIcon } from '../../../../assets/images/services/InternetPlusCabellTv.svg';
import { ReactComponent as InternetPlusBrizTvIcon } from '../../../../assets/images/services/InternetPlusBrizTv.svg';
import { ReactComponent as InternetPlusTvMaxIcon } from '../../../../assets/images/services/InternetPlusTvMax.svg';

interface AccountIconProps {
  accountType: ServiceCardIconType;
}

export const AccountIcon: FC<AccountIconProps> = ({ accountType }) => {
  const getIcon = (type: ServiceCardIconType) => {
    switch (type) {
      case ServiceCardIconType.Internet:
        return <InternetIcon />;
      case ServiceCardIconType.Ctv:
        return <CabellTvIcon />;
      case ServiceCardIconType.Iptv:
        return <BrizTvIcon />;
      case ServiceCardIconType.InternetCtv:
        return <InternetPlusCabellTvIcon />;
      case ServiceCardIconType.InternetIptv:
        return <InternetPlusBrizTvIcon />;
      case ServiceCardIconType.InternetTvMax:
        return <InternetPlusTvMaxIcon />;
      default:
        return <InternetIcon />;
    }
  };

  return <div className="icon">{getIcon(accountType)}</div>;
};
